import { useState, useEffect } from 'react';
import API from '../api';

const fmt = v => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(v || 0);
const emptyForm = { cliente: '', servicio: '', valor: '', costo: '', proveedor: 'Ageinformatica' };
const inputStyle = { background: '#f4f7fa', border: '1px solid #e8eef2', color: '#08293f' };

export default function ClientesFijos() {
  const [fijos,    setFijos]    = useState([]);
  const [form,     setForm]     = useState(emptyForm);
  const [editId,   setEditId]   = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [msg,      setMsg]      = useState('');

  const cargar = () => API.get('/clientes-fijos').then(r => setFijos(r.data));
  useEffect(() => { cargar(); }, []);

  const totalMensual = fijos.reduce((s, f) => s + parseFloat(f.valor || 0), 0);

  async function cargarMes() {
    if (!window.confirm('¿Cargar todos los clientes fijos para el mes actual como PENDIENTE?')) return;
    setLoading(true);
    try {
      const { data } = await API.post('/clientes-fijos/cargar-mes', { estado: 'PENDIENTE' });
      setMsg(`✓ Se cargaron ${data.count} registros del mes correctamente`);
      setTimeout(() => setMsg(''), 5000);
    } catch (err) {
      const error = err.response?.data?.error;
      setMsg(error === 'YA_CARGADO' ? '⚠ Los clientes fijos ya fueron cargados este mes' : 'Error: ' + error);
      setTimeout(() => setMsg(''), 5000);
    } finally { setLoading(false); }
  }

  async function guardar(e) {
    e.preventDefault(); setLoading(true);
    try {
      if (editId) await API.put(`/clientes-fijos/${editId}`, form);
      else        await API.post('/clientes-fijos', form);
      setShowForm(false); setEditId(null); setForm(emptyForm);
      cargar();
    } catch (err) { alert('Error: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  }

  function editar(f) {
    setForm({ cliente: f.cliente, servicio: f.servicio, valor: f.valor, costo: f.costo, proveedor: f.proveedor });
    setEditId(f.id); setShowForm(true);
  }

  const msgIsError = msg.startsWith('Error');
  const msgIsWarn  = msg.startsWith('⚠');

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#08293f', margin: 0 }}>Clientes Fijos</h1>
          <p style={{ fontSize: 11, color: '#5a7a8a', letterSpacing: '0.06em', marginTop: 4 }}>Contratos mensuales recurrentes</p>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn-dark" onClick={cargarMes} disabled={loading} style={{ letterSpacing: '0.04em', fontSize: 12 }}>
            {loading ? 'Cargando...' : '⚡ Cargar mes actual'}
          </button>
          <button className="btn-primary" onClick={() => { setForm(emptyForm); setEditId(null); setShowForm(true); }}>+ Agregar</button>
        </div>
      </div>

      {msg && (
        <div style={{ marginBottom: 16, padding: '10px 14px', fontSize: 13, fontWeight: 600, borderRadius: 2,
          background: msgIsError ? 'rgba(248,113,113,0.1)' : msgIsWarn ? 'rgba(251,191,36,0.1)' : 'rgba(0,184,227,0.1)',
          border: `1px solid ${msgIsError ? 'rgba(248,113,113,0.3)' : msgIsWarn ? 'rgba(251,191,36,0.3)' : 'rgba(0,184,227,0.3)'}`,
          color: msgIsError ? '#dc2626' : msgIsWarn ? '#b45309' : '#00b8e3' }}>
          {msg}
        </div>
      )}

      {/* KPIs */}
      <div className="fijos-kpi-grid" style={{ marginBottom: 16 }}>
        {[
          { label: 'Contratos activos',         value: fijos.length,           accent: false },
          { label: 'Ingreso mensual recurrente', value: fmt(totalMensual),     accent: true  },
          { label: 'Con IVA 19%',               value: fmt(totalMensual*1.19), accent: false },
        ].map((k, i) => (
          <div key={i} style={{ background: k.accent ? '#08293f' : '#fff', border: k.accent ? '1px solid rgba(0,184,227,0.3)' : '1px solid #e8eef2', padding: '16px 18px', borderRadius: 2 }}>
            <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: k.accent ? 'rgba(0,184,227,0.6)' : '#5a7a8a', marginBottom: 6 }}>{k.label}</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: k.accent ? '#00b8e3' : '#08293f' }}>{k.value}</div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showForm && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: 500 }}>
            <div style={{ padding: 28 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
                <div>
                  <h2 style={{ fontSize: 14, fontWeight: 700, color: '#08293f', margin: 0, letterSpacing: '0.04em', textTransform: 'uppercase' }}>{editId ? 'Editar cliente fijo' : 'Nuevo cliente fijo'}</h2>
                  <div style={{ width: 32, height: 2, background: '#00b8e3', marginTop: 6 }} />
                </div>
                <button onClick={() => setShowForm(false)} style={{ fontSize: 20, fontWeight: 300, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
              </div>
              <form onSubmit={guardar}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                  <div><label className="label">Cliente *</label>
                    <input className="input" value={form.cliente} style={inputStyle}
                      onChange={e => setForm(f => ({ ...f, cliente: e.target.value }))} required /></div>
                  <div><label className="label">Servicio *</label>
                    <input className="input" value={form.servicio} style={inputStyle}
                      onChange={e => setForm(f => ({ ...f, servicio: e.target.value }))} required /></div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                  <div><label className="label">Valor mensual</label>
                    <input className="input" type="number" value={form.valor} style={inputStyle}
                      onChange={e => setForm(f => ({ ...f, valor: e.target.value }))} required min="0" /></div>
                  <div><label className="label">Costo</label>
                    <input className="input" type="number" value={form.costo} style={inputStyle}
                      onChange={e => setForm(f => ({ ...f, costo: e.target.value }))} min="0" /></div>
                </div>
                <div style={{ marginBottom: 20 }}><label className="label">Proveedor</label>
                  <input className="input" value={form.proveedor} style={inputStyle}
                    onChange={e => setForm(f => ({ ...f, proveedor: e.target.value }))} /></div>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button type="submit" disabled={loading} className="btn-primary" style={{ flex: 1, padding: 10 }}>{loading ? 'Guardando...' : editId ? 'Actualizar' : 'Guardar'}</button>
                  <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Desktop tabla */}
      <div className="fijos-tabla-desktop card" style={{ overflowX: 'auto', padding: 0 }}>
        <table className="tbl">
          <thead>
            <tr>
              {['Cliente','Servicio','Valor','Costo','Utilidad','Con IVA','Proveedor',''].map(h => (
                <th key={h} style={{ textAlign: ['Valor','Costo','Utilidad','Con IVA'].includes(h) ? 'right' : 'left' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fijos.map(f => (
              <tr key={f.id}>
                <td style={{ fontWeight: 700, color: '#08293f' }}>{f.cliente}</td>
                <td style={{ color: '#5a7a8a', fontSize: 12 }}>{f.servicio}</td>
                <td style={{ textAlign: 'right', fontWeight: 700, color: '#08293f' }}>{fmt(f.valor)}</td>
                <td style={{ textAlign: 'right', color: '#5a7a8a' }}>{fmt(f.costo)}</td>
                <td style={{ textAlign: 'right', fontWeight: 600, color: '#059669' }}>{fmt(f.valor - f.costo)}</td>
                <td style={{ textAlign: 'right', color: '#b45309' }}>{fmt(f.valor * 1.19)}</td>
                <td style={{ color: '#b3b3b3', fontSize: 12 }}>{f.proveedor}</td>
                <td><button onClick={() => editar(f)} style={{ fontSize: 11, color: '#00b8e3', background: 'none', border: 'none', cursor: 'pointer' }}>Editar</button></td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: '2px solid #e8eef2', background: '#f4f7fa' }}>
              <td colSpan={2} style={{ padding: '10px 12px', fontWeight: 700, color: '#08293f', fontSize: 11, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Total mensual</td>
              <td style={{ textAlign: 'right', padding: '10px 12px', fontWeight: 700, color: '#00b8e3' }}>{fmt(totalMensual)}</td>
              <td colSpan={2} />
              <td style={{ textAlign: 'right', padding: '10px 12px', fontWeight: 700, color: '#b45309' }}>{fmt(totalMensual * 1.19)}</td>
              <td colSpan={2} />
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="fijos-cards-mobile">
        {fijos.map(f => (
          <div key={f.id} style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, padding: '14px 16px', marginBottom: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <div>
                <div style={{ fontWeight: 700, color: '#08293f', fontSize: 14 }}>{f.cliente}</div>
                <div style={{ fontSize: 11, color: '#5a7a8a', marginTop: 2 }}>{f.servicio}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#08293f' }}>{fmt(f.valor)}</div>
                <div style={{ fontSize: 11, color: '#b45309' }}>{fmt(f.valor * 1.19)} c/IVA</div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 16, marginBottom: 10 }}>
              <div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#5a7a8a', marginBottom: 2 }}>Costo</div>
                <div style={{ fontSize: 12, color: '#5a7a8a' }}>{fmt(f.costo)}</div>
              </div>
              <div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#5a7a8a', marginBottom: 2 }}>Utilidad</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#059669' }}>{fmt(f.valor - f.costo)}</div>
              </div>
              <div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#5a7a8a', marginBottom: 2 }}>Proveedor</div>
                <div style={{ fontSize: 12, color: '#b3b3b3' }}>{f.proveedor}</div>
              </div>
            </div>
            <button onClick={() => editar(f)} style={{ fontSize: 11, fontWeight: 600, color: '#00b8e3', background: 'rgba(0,184,227,0.08)', border: '1px solid rgba(0,184,227,0.2)', padding: '5px 12px', cursor: 'pointer', borderRadius: 2 }}>Editar</button>
          </div>
        ))}

        {/* Mobile total */}
        <div style={{ background: '#08293f', borderRadius: 2, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'rgba(0,184,227,0.6)' }}>Total mensual</span>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#00b8e3' }}>{fmt(totalMensual)}</div>
            <div style={{ fontSize: 11, color: '#b45309' }}>{fmt(totalMensual * 1.19)} c/IVA</div>
          </div>
        </div>
      </div>

      <style>{`
        .fijos-kpi-grid      { display: grid; grid-template-columns: repeat(3,1fr); gap: 8px; }
        .fijos-tabla-desktop { display: block; }
        .fijos-cards-mobile  { display: none; }
        @media (max-width: 768px) {
          .fijos-kpi-grid      { grid-template-columns: repeat(2,1fr); }
          .fijos-tabla-desktop { display: none; }
          .fijos-cards-mobile  { display: block; }
        }
      `}</style>
    </div>
  );
}
